<template>
  <div class="wrap-alert-conten-w">
    <v-card class="d-flex pa-1 bg" outlined>
      <div class="mr-auto d-flex">
        <system-linked-combo v-model="select" :last-item="{ value: '*', text: 'Default' }" hide-stack></system-linked-combo>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" class="append-align-right mr-2" @click="formOpen('new', null)" x-small color="primary"><v-icon small>mdi-plus-circle-outline</v-icon></v-btn>
          </template>
          <span>{{ $t('common.add') }}</span>
        </v-tooltip>
      </div>
    </v-card>
    <v-data-table :headers="headers" :items="cloneWhitelist" item-key="sequence" :loading="loadings.table" class="elevation-1 content td-spd" height="560px" dense fixed-header disable-pagination hide-default-footer>
      <template v-slot:top>
        <WhiteListForm :formData="formItem" :formMode="formMode" ref="whiteListFormComp" />
      </template>
      <template v-slot:item.active="{ item }">
        <v-simple-checkbox v-model="item.active" disabled class="sp-chk-dense chk-align-c"></v-simple-checkbox>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" small class="mr-2" color="primary" @click="formOpen('edit', item)">mdi-pencil-box-multiple-outline</v-icon>
          </template>
          <span>{{ $t('common.edit') }}</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" small color="primary" @click="deleteItem(item)">mdi-trash-can-outline</v-icon>
          </template>
          <span>{{ $t('common.delete') }}</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import WhiteListForm from './WhiteListForm';

export default {
  name: 'WhiteList',
  components: {
    WhiteListForm,
  },
  data() {
    return {
      loadings: { table: true },
      select: { stack: 'ABAP', system: '' },
      cloneWhitelist: [],
      formMode: '',
      formItem: {},
      newWhiteList: {
        alertWhitelistType: '',
        active: true,
        taskType: '',
        account: '',
        tcode: '',
        report: '',
        rfcFunctionName: '',
        description: '',
      },
    };
  },
  computed: {
    ...mapState('preference/alert', ['whitelist']),
    headers() {
      return [
        { text: this.$t('alert.whitelist.filterType'), value: 'alertWhitelistTypeName', sortable: false },
        { text: this.$t('alert.whitelist.taskType'), value: 'taskType.text', sortable: false },
        { text: this.$t('alert.whitelist.sapUserId'), value: 'account', sortable: false },
        { text: this.$t('alert.whitelist.tcode'), value: 'tcode', sortable: false },
        { text: this.$t('alert.whitelist.report'), value: 'report', sortable: false },
        { text: this.$t('alert.whitelist.rfcFunctionName'), value: 'rfcFunctionName', sortable: false },
        { text: this.$t('alert.active'), value: 'active', sortable: false },
        { text: this.$t('alert.description'), value: 'description', sortable: false },
        { text: '', value: 'actions', sortable: false },
      ];
    },
  },
  watch: {
    whitelist(value) {
      this.cloneWhitelist = value;
    },
    cloneWhitelist() {
      this.$nextTick(() => {
        this.loadings.table = false;
      });
    },
    'select.system'() {
      this.fetchWhiteList();
    },
  },
  created() {
    this.$store.dispatch('preference/alert/whitelistTypes');
    this.$store.dispatch('preference/alert/taskTypes');
  },
  methods: {
    fetchWhiteList() {
      this.loadings.table = true;
      this.$store.dispatch('preference/alert/whitelist', { systemId: this.select.system });
    },
    formOpen(formType = 'new', ...item) {
      this.formItem = {};
      this.formMode = formType;

      if (formType === 'new') {
        this.formItem = {
          systemId: this.select.system,
          ...this.newWhiteList,
        };
      } else {
        this.formItem = {
          ...item[0],
          taskType: item[0].taskType.text,
        };
      }
      this.$refs.whiteListFormComp.$data.show = true;
    },
    async deleteItem(item) {
      if (await this.$dialog.confirm(this.$t('common.delete.q'))) {
        this.fetchDeleteWhitelist(item);
      }
    },
    fetchDeleteWhitelist(item) {
      const params = {
        systemId: this.select.system,
        sequence: item.sequence,
      };
      this.$store.dispatch('preference/alert/deleteWhitelist', params);
    },
  },
};
</script>
